<template>
  <div>
    <px-circular-loading v-if="loading"/>
    <div v-if="!loading && !links.length">
      Nenhum link para esse registro
    </div>
    <v-simple-table
      v-if="!loading && links.length"
      fixed-header
    >
      <template v-slot:default>
        <thead>
        <tr>
          <th>Link</th>
          <th>Identificador</th>
          <th class="text-center"></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="link in links" :key="link.id">
          <td>
            {{ linkDescription(link) }} #{{ link.id }}
            <px-span-tooltip
              v-if="link.codigoInterno"
              bottom
              text-class="caption"
              :text="`(${link.codigoInterno})`"
              tooltip="Código no ERP"/>
          </td>
          <td>
            {{ linkIdentificador(link) }}
          </td>
          <td>
            <px-cotacao-resposta-dialog-view v-if="isCotacao(link)" :cotacao-id="link.id" />
            <px-compra-detalhes-dialog-view v-if="isCompra(link)" :compra-id="link.id" />
            <px-requisicao-detalhes-dialog-view v-if="isRequisicao(link)"
                                                :requisicao-id="link.id" />
            <v-btn icon target="_blank" link :to=linkRedirect(link)>
              <v-icon>mdi-open-in-new</v-icon>
            </v-btn>
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import AprovacaoService from '@/modules/aprovacao/aprovacao-service';

const LINK_DESCRIPTION_MAP = {
  COTACAO: 'Cotação',
  COMPRA: 'Compra',
  REQUISICAO: 'Solicitação',
};

const LINK_URL_MAP = {
  COTACAO: link => `/cotacao/${link.id}/respostas`,
  COMPRA: link => `/compra/${link.id}/detalhes`,
  REQUISICAO: link => `/requisicao/${link.id}`,
};

export default {
  props: {
    aprovacao: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      links: [],
    };
  },
  computed: {
    isCotacao() {
      return link => link.tipo === 'COTACAO';
    },
    isCompra() {
      return link => link.tipo === 'COMPRA';
    },
    isRequisicao() {
      return link => link.tipo === 'REQUISICAO';
    },
    linkDescription() {
      return link => (LINK_DESCRIPTION_MAP[link.tipo] || '');
    },
    linkRedirect() {
      return link => (LINK_URL_MAP[link.tipo](link));
    },
    linkIdentificador() {
      return link => (link.identificador ? link.identificador : '-');
    },
  },
  methods: {
    getLinks() {
      this.loading = true;
      AprovacaoService.getLinks(this.aprovacao.id)
        .then(({ data }) => {
          this.links = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getLinks();
  },
  components: {
    pxCotacaoRespostaDialogView: () => import('@/modules/cotacao/resposta/CotacaoRespostaDialogView.vue'),
    pxCompraDetalhesDialogView: () => import('@/modules/compra/detalhes/CompraDetalhesDialogView.vue'),
    pxRequisicaoDetalhesDialogView: () => import('@/modules/requisicao/detalhes/RequisicaoDetalhesDialogView.vue'),
  },
};
</script>
